import React, { useRef, useEffect, useState } from "react";
import { get } from "util/requests";
import { DataGrid } from "@mui/x-data-grid";
import styles from "./deviations.module.css";

import AETable from "./components/deviations_table";

export default function Audit() {
  return (
    <div className={styles.flex}>
      <div className={styles.header}>
        <div>
          <h3>Protocol Deviations</h3>
        </div>
        <div className={styles.search_wrapper}></div>
      </div>
      <AETable />
    </div>
  );
}
